import { useEffect } from "react";
import lenis from './lenis';

function useSmoothScroll(){
    useEffect(() => {
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };

        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
        };
    }, []);
}

export default useSmoothScroll;